module.exports = __webpack_public_path__ + "a3fb7228318b73fd17de67271cdefb61.jpg";